import { useTranslation } from 'react-i18next';

import ChartWheel from './ChartWheel';
import LifeThemeCard from './LifeThemeCard';
import PlanetCard from './PlanetCard';
import styles from './styles.module.scss';

const PLANET_LIMIT = 3;

/**
 * Birth Chart tab: wheel, glance, life themes, planets, then `children` (the
 * host's CTAs). `planetLimit` caps the planet cards; the app shows a teaser.
 */
const ChartTab = ({ report, planetLimit = PLANET_LIMIT, children }) => {
    const { t } = useTranslation();
    const { placements, content } = report;
    const themes = content.lifeThemes || [];
    const planets = (content.planets || []).slice(0, planetLimit);
    const bodyByKey = Object.fromEntries((placements?.bodies || []).map((body) => [body.key, body]));

    return (
        <div id="bc-panel-chart" role="tabpanel" aria-labelledby="bc-tab-chart">
            <ChartWheel placements={placements} />

            {content.glance && (
                <section className={styles.block}>
                    <h3 className={styles.eyebrow}>{t('birthChart.view.chart.glance')}</h3>
                    <p className={styles.placementCopy}>{content.glance}</p>
                </section>
            )}

            {themes.length > 0 && (
                <section className={styles.block} data-testid="life-themes">
                    <h3 className={styles.eyebrow}>{t('birthChart.view.chart.lifeThemes')}</h3>
                    <div className={styles.scroller}>
                        {themes.map((theme, index) => (
                            <LifeThemeCard key={`${theme.title}-${index}`} theme={theme} index={index} />
                        ))}
                    </div>
                </section>
            )}

            {planets.length > 0 && (
                <section className={styles.block} data-testid="planets">
                    <h3 className={styles.eyebrow}>{t('birthChart.view.chart.planets')}</h3>
                    <div className={styles.scroller}>
                        {planets.map((planet) => (
                            <PlanetCard key={planet.key} planet={planet} body={bodyByKey[planet.key]} />
                        ))}
                    </div>
                </section>
            )}

            {children}
        </div>
    );
};

export default ChartTab;
